import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

const Welcome = ({ moduleName }) => {
  return (
    <Typography
      variant="h1"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center'
      }}
    >
      {`Welcome to ${moduleName}`}
    </Typography>
  )
}
Welcome.propTypes = {
  moduleName: PropTypes.string.isRequired
}

export default Welcome
